export default "__VITE_ASSET__Bkupib8h__"